import { PropsWithChildren } from "react";
import ApiReference from "../../content/en/api-reference/_index";
import Datasheets from "../../content/en/datasheets/_index";
import Docs from "../../content/en/docs/_index";
import GuidesAndTutorials from "../../content/en/guides-and-tutorials/_index";
import LoRa from "../../content/en/lora/_index";
import Notecard from "../../content/en/notecard/_index";
import Notehub from "../../content/en/notehub/_index";
import Quickstart from "../../content/en/quickstart/_index";
import ToolsAndSDKs from "../../content/en/tools-and-sdks/_index";

type LandingPagesType = {
  [name: string]: (a: any) => JSX.Element;
};

const SearchEngineH1 = ({ children }: PropsWithChildren) => (
  <h1 style={{ visibility: "hidden" }}>{children}</h1>
);

const LandingPages: LandingPagesType = {
  "api-reference": ApiReference,
  datasheets: Datasheets,
  docs: Docs,
  "guides-and-tutorials": GuidesAndTutorials,
  lora: LoRa,
  notecard: Notecard,
  notehub: Notehub,
  quickstart: Quickstart,
  terminal: () => <SearchEngineH1>In-Browser Terminal</SearchEngineH1>,
  "tools-and-sdks": ToolsAndSDKs,
};

// Determine the type of menu a given landing page should use. The “main”
// menu shows all top-level menu options, and the “galaxy” menu shows only
// sub-menu options from within a single galaxy. Needed to make docs landing page
// display the main menu, and all other landing pages display the galaxy menu.
export function determineMenuType(landingPage: string) {
  return ["docs"].includes(landingPage) ? "main" : "galaxy";
}

export default LandingPages;
